import React from 'react';
import { Button } from 'react-bootstrap';
import PropTypes from 'prop-types';

/*
  Example of SpinnerButton:
  <SpinnerButton
    bsStyle="success"
    onClick={() => {
      this.customOnClick();
    }}
    loading={this.props.somethingIsLoading}
    icon={"default button icon"}
    translation={"normal_translation_format"}
  />
*/

const SpinnerButton = props => (
  <Button
    bsStyle="primary"
    type="button"
    {...props}
  >
    <em className={`fa ${props.loading ? 'fa-spinner fa-spin' : props.icon}`} />
    { props.translation }
  </Button>
);

SpinnerButton.defaultProps = {
  icon: '',
  loading: false,
  translation: '',
};

SpinnerButton.propTypes = {
  icon: PropTypes.string,
  loading: PropTypes.bool,
  translation: PropTypes.node,
};

export default SpinnerButton;



// WEBPACK FOOTER //
// ./master/jsx/components/Common/SpinnerButton.jsx